// src/icons/LogoBolt.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function LogoBolt() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 20 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_1383_30073)", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M31.6927 15.3862H27.765V8.21623H26.7521V16.3799H32.6996V12.7227H31.6927V15.3862Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M35.856 9.20419H37.9936V15.3862H35.856V16.3799H41.1146V15.3862H39.0064V9.20419H41.1146V8.21623H35.856V9.20419Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M49.6235 15.3862H47.4506C46.3671 15.3862 45.9844 15.2129 45.8489 15.1147C45.6428 14.9587 45.5427 14.6525 45.5427 14.2076V10.4175C45.5427 9.9611 45.6369 9.63178 45.8254 9.47001C45.9373 9.37179 46.267 9.20424 47.1798 9.20424H50.0004V8.2105H47.1798C46.161 8.2105 45.5015 8.37805 45.1129 8.73048C44.7301 9.08291 44.5358 9.64911 44.5358 10.4118V14.2018C44.5358 14.56 44.577 14.872 44.6594 15.132C44.7537 15.4382 44.9303 15.6924 45.1894 15.8889C45.425 16.068 45.7429 16.2009 46.1316 16.276C46.479 16.3453 46.9266 16.38 47.4565 16.38H50.6364V12.8037H49.6235V15.3862Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M59.8698 11.7983H55.4474V8.21623H54.4346V16.3799H55.4474V12.7921H59.8698V16.3799H60.8826V8.21623H59.8698V11.7983Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M64.0919 9.20419H66.9184V16.3799H67.9312V9.20419H70.7578V8.21623H64.0919V9.20419Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M77.9949 12.0525L75.0742 11.469C74.9505 11.4459 74.8622 11.4112 74.7974 11.3419C74.7974 11.3419 74.7326 11.2668 74.7326 10.9837V9.87439C74.7326 9.67795 74.7974 9.53352 74.9387 9.40641C75.0859 9.27353 75.2861 9.20997 75.5688 9.20997H79.0666V8.21623H75.5688C75.0329 8.21623 74.5913 8.37223 74.2556 8.67266C73.9023 8.98465 73.7257 9.38908 73.7257 9.87439V10.9837C73.7257 11.4806 73.8434 11.833 74.0908 12.0583C74.3027 12.2547 74.5736 12.3819 74.8916 12.4454L77.7947 13.0289C77.9655 13.0636 78.095 13.1272 78.1833 13.2196C78.1951 13.2312 78.2893 13.3467 78.2893 13.7974V14.5831C78.2893 14.8258 78.2128 15.0049 78.0479 15.1551C77.8771 15.3111 77.6416 15.3862 77.3295 15.3862H73.4607V16.3799H77.3295C77.9125 16.3799 78.3894 16.2124 78.7487 15.8773C79.1137 15.5364 79.2963 15.1031 79.2963 14.5831V13.7974C79.2963 13.208 79.1667 12.7921 78.9018 12.5263C78.6603 12.2836 78.3541 12.1276 77.9949 12.0525Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M88.4001 8.88643C88.2058 8.67266 87.9349 8.49933 87.5933 8.38378C87.2753 8.27401 86.869 8.21623 86.3921 8.21623H82.9767V16.3799H83.9895V13.7165H86.3921C86.869 13.7165 87.2754 13.6645 87.5875 13.5605C87.929 13.4449 88.1999 13.2832 88.4001 13.0694C88.5944 12.8614 88.7298 12.6072 88.8064 12.3125C88.8712 12.0583 88.9006 11.781 88.9006 11.4863V10.4868C88.9006 10.1922 88.8712 9.91484 88.8064 9.65484C88.7357 9.36019 88.6003 9.10598 88.406 8.88643H88.4001ZM83.9836 9.20419H86.3862C86.7395 9.20419 87.0221 9.23886 87.2282 9.30819C87.4108 9.37174 87.5462 9.44685 87.6287 9.54507C87.717 9.64329 87.7818 9.76462 87.8171 9.90328C87.8583 10.0766 87.8819 10.273 87.8819 10.481V11.4806C87.8819 11.6885 87.8583 11.8792 87.8171 12.0468C87.7818 12.1854 87.7229 12.2894 87.6346 12.3876C87.5462 12.4801 87.4167 12.5552 87.2341 12.613C87.028 12.6823 86.7395 12.7112 86.3862 12.7112H83.9836V9.19842V9.20419Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M98.2224 11.6019L97.2684 9.38908C97.1448 9.1002 97.0093 8.85176 96.868 8.65533C96.7208 8.45311 96.4322 8.21623 95.8728 8.21623H94.5184C93.9472 8.21623 93.6528 8.45311 93.5056 8.64955C93.3525 8.85176 93.2229 9.09442 93.1052 9.3833L92.2219 11.6134C92.1394 11.833 92.0747 12.0583 92.0334 12.2952C91.9863 12.5321 91.9628 12.7978 91.9628 13.0752V16.3857H92.9756V14.0573H97.4804V16.3857H98.4933V13.0752C98.4933 12.7978 98.4697 12.5378 98.4226 12.2952C98.3755 12.0583 98.3107 11.8272 98.2283 11.6077L98.2224 11.6019ZM94.3006 9.25619C94.3006 9.25619 94.383 9.20419 94.5184 9.20419H95.8728C95.9317 9.20419 96.0318 9.20997 96.0672 9.25619C96.1614 9.38908 96.2556 9.5624 96.3439 9.7704L97.2861 11.9485C97.345 12.1103 97.3921 12.2894 97.4274 12.4743C97.4627 12.6534 97.4804 12.8498 97.4804 13.0578H92.9756C92.9756 12.8441 92.9933 12.6476 93.0286 12.4743C93.0639 12.2894 93.1111 12.1161 93.1641 11.9659L94.0474 9.74729C94.1239 9.55085 94.2122 9.38908 94.3064 9.25619H94.3006Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M107.621 12.3761C107.621 12.3761 107.644 12.3241 107.656 12.301C107.785 11.9832 107.856 11.5846 107.856 11.1166V10.1806C107.856 9.63756 107.691 9.16957 107.361 8.79981C107.02 8.40694 106.508 8.2105 105.842 8.2105H102.262V16.3742H103.275V13.237H106.743C107.149 13.237 107.444 13.3121 107.609 13.4565C107.762 13.5952 107.838 13.8147 107.838 14.1325V16.3742H108.851V14.1325C108.851 13.5432 108.663 13.0752 108.298 12.7401C108.115 12.5783 107.891 12.457 107.626 12.3761H107.621ZM105.842 9.20424C106.195 9.20424 106.449 9.28513 106.596 9.45268C106.761 9.63756 106.837 9.86866 106.837 10.1864V11.1339C106.837 11.5384 106.767 11.8446 106.625 12.041C106.525 12.1855 106.243 12.2664 105.836 12.2664H103.263V9.21002H105.836L105.842 9.20424Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M118.326 12.2143C117.99 11.9601 117.513 11.8272 116.901 11.8157L118.485 8.21623H117.384L115.8 11.8157H113.527V8.21623H112.514V16.3799H113.527V12.8094H116.801C117.207 12.8094 117.513 12.8729 117.69 13.0001C117.743 13.0347 117.896 13.1445 117.896 13.572V16.3799H118.909V13.572C118.909 12.9654 118.715 12.509 118.326 12.2143Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M10.0695 12.7915H2.78532L13.0727 3.95763L11.0588 8.23881H12.213L16.0877 0L0 13.8199H9.58667L10.0695 12.7915Z",
              fill: "currentColor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M10.1461 10.1801L9.66324 11.2085H16.9475L6.66004 20.0424L8.67395 15.7612H7.51978L3.64507 24L19.7328 10.1801H10.1461Z",
              fill: "currentColor"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1383_30073", children: /* @__PURE__ */ jsx("rect", { width: "20", height: "24", fill: "currentColor" }) }) })
      ]
    }
  );
}

export {
  LogoBolt
};
